var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarContacted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4h20v16H2V4zm2 2v12h16V6H4zm1.5 1.5l6.5 5.25 6.5-5.25H5.5zm0 1.5v7.50h12.5v-7.5l-6 4.875L5.5 9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarContacted);
export default __webpack_public_path__ + "static/media/icon-mar-contacted.c5c8f8744cf9d8620767a6f2d0250498.svg";
export { ForwardRef as ReactComponent };